import { QUICK_REPLY_ANSWER_MESSAGE_KIND } from './quickReply';

const hasQuickReplyAnswerKind = (value: unknown): boolean => {
  if (!value || typeof value !== 'object') return false;

  const data = (value as { data?: unknown }).data;
  return (
    !!data &&
    typeof data === 'object' &&
    (data as { messageKind?: unknown }).messageKind ===
      QUICK_REPLY_ANSWER_MESSAGE_KIND
  );
};

/** Unread badge: uuid-channel events are flat, history/list shapes nest the payload. */
const isQuickReplyAnswerMessage = (value: unknown): boolean =>
  hasQuickReplyAnswerKind(value) ||
  hasQuickReplyAnswerKind((value as { message?: unknown } | null)?.message);

export default isQuickReplyAnswerMessage;
